import {
  CheckBox,
  CheckBoxOutlineBlank,
  IndeterminateCheckBox,
  Info,
} from '@mui/icons-material'
import * as S from './InformationCaption.style'
import { Divider, Typography } from '@mui/material'

interface InformationCaptionProps {
  moreInformation?: React.ReactNode
  width?: string
}

const InformationCaption = ({ moreInformation, width = '29.8%' }: InformationCaptionProps) => (
  <S.Container width={width}>
    <S.Title>
      <Typography sx={{ fontWeight: 'bold' }}>Informativo</Typography>
      <Divider />
    </S.Title>
    <S.Item>
      <CheckBox color='info'/>
      <Typography>Todos os itens selecionados possuem o atributo</Typography>
    </S.Item>
    <S.Item>
      <IndeterminateCheckBox color='info'/>
      <Typography>Alguns dos itens selecionados possuem o atributo</Typography>
    </S.Item>
    <S.Item>
      <CheckBoxOutlineBlank color='info'/>
      <Typography>Nenhum dos itens selecionados possuem o atributo</Typography>
    </S.Item>
    {
      moreInformation && (
        <S.MoreInformation>
          <Info color='info' />
          <S.Information>{ moreInformation }</S.Information>
        </S.MoreInformation>
      )
    }
  </S.Container>
)

export default InformationCaption
